import React from 'react';
import moment from 'moment';
import '../../css/formats.css';
import { CURRENCY, Datos_Empresa, FORMAT_NUMBER, SYMBOL } from "../../libs/utils/Const";
import { NumeroLetra } from '../NewOrder';
import { development } from "../../libs/utils/Const";

class MoneyOut extends React.Component {


    render() {
       
        return (
            <div>
                <div className='row'>
                    <div className='col-4'></div>
                    <div className='col-4'>
                        <div style={{ backgroundColor: 'white', width: "322px", height: "auto", marginLeft: "auto", marginRight: "auto", border: "solid 1px" }}>
                            
                            <div className='row'>
                                <div className="col-12 text-center text-ticket">
                                    <img src={development? require('../../images/logo_draft.svg') : require('../../images/logo_EMPRESA.svg')} alt="Logo" style={{ maxWidth: "170px" }} />
                                    <p><strong>{Datos_Empresa.Nombre}<br />{Datos_Empresa.Sociedad}<br /></strong></p>
                                    <p >COL. C.P.;,.</p>
                                    <span >Tel. TEL_{Datos_Empresa.Name} Cel. CEL_{Datos_Empresa.Name}</span>
                                </div>
                            </div>
                            <div className='row p-2'>
                                <div className='col-12 text-center'>
                                    <span><strong>SALIDA DE DINERO</strong></span>
                                </div>
                            </div>
                            <div className='row p-3'>
                                <div className='col-12 text-ticket '>
                                    <table>
                                        <tbody style={{ borderBottom: "solid 2px" }}>
                                            <tr>
                                                <td>FOLIO: </td>
                                                <td className='text-right' style={{ fontWeight: "bold" }}>00000</td>
                                            </tr>
                                            <tr>
                                                <td>FECHA: </td>
                                                <td className='text-right' style={{ fontWeight: "bold" }}>00/00/00 00:00</td>
                                            </tr>
                                            <br />
                                            <tr>
                                                <td>CAJERO(A): </td>
                                                <td className='text-right'>FMB001</td>
                                            </tr>
                                            <tr>
                                                <td>NOMBRE: </td>
                                                <td className='text-right'>OSVALDO GALINDO</td>
                                            </tr>
                                            <br />
                                            
                                            
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            
                            <div className='row pl-3 pr-3'>
                                <div className='col-12 text-ticket '>
                                    
                                    <table>
                                        <tbody>
                                            <tr style={{fontSize: "16px"}}>
                                                <td className='text-center'>EFECTIVO:</td>
                                                
                                            </tr>
                                        </tbody>                                                       
                                    </table>
                                    <br />
                                    <table>
                                        <thead>
                                            <tr style={{fontSize: "14px"}}>
                                                <th className='text-center'>$45</th>
                                            </tr>
                                        </thead>
                                    </table>
                                    <br />
                                    <br />
                                    <br />
                                    <table>
                                        <tbody style={{ borderTop: "solid 2px" }}>
                                            <tr>
                                                <td className='text-center'>FIRMA</td>
                                            </tr>
                                            <br />
                                        </tbody>
                                    </table>
                                    
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <div className='col-4'></div>

                </div>

            </div>
        )
    }
}

export default MoneyOut